export function isPathExternal(path?: string): boolean {
  if (!path) {
    return false;
  }

  if (path.startsWith("http")) {
    return true;
  }

  return false;
}
